import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import styles from './OtpHeaderStep.module.css';

const OtpHeaderStep = ({ email = '' }) => {
  const { t } = useTranslation('petDemos');

  return (
    <div className={styles.mainContainer}>
      <p>{t('certificateLinking.authorizationCodeScreen.header.section')}</p>

      <h1>{t('certificateLinking.authorizationCodeScreen.header.title')}</h1>

      <span>
        <Trans
          components={{
            b: <span className={styles.descriptionBold} />,
          }}
          i18nKey={'certificateLinking.authorizationCodeScreen'
            + '.header.description'}
          t={t}
          values={{ email }}
        />
      </span>
    </div>
  );
};

export { OtpHeaderStep };
